export default __webpack_public_path__ + "static/contact-izq-47294774100a7706e14adc61ac8d75f9.png";